import React, { useState } from 'react';
import { BrowserRouter as Router, Route, Routes, Navigate } from 'react-router-dom'; // Importando o Navigate
import Home from './Components/Home';
import QuadroObreiroPage from './Components/QuadroObreiroPage';
import IniciacaoPage from './Components/IniciacaoPage';
import AniversarioPage from './Components/AniversarioPage';
import MemoriasFotograficasPage from './Components/MemoriasFotograficasPage';
import IframePage from './Components/IframePage';
import Login from './Components/Login'; // Componente de Login
import CriarSenha from './Components/CriarSenha';
import DynamicPage, { DynamicContentPage } from './Components/DynamicPage';
import PerfilPage from './Components/PerfilPage';
import GaleriaDetailPage from './Components/GaleriaDetailPage';
const App = () => {
  const [user, setUser] = useState(() => {
    const storedUser = sessionStorage.getItem('user');
    return storedUser ? JSON.parse(storedUser) : null;
  });

  const PrivateRoute = ({ element }) => {
    return user ? element : <Navigate to="/login" />;
  };

  return (
    <Router>
      <Routes>
        <Route path="/" element={<PrivateRoute element={<Home user={user} setUser={setUser} />} />} />
        <Route path="/login" element={<Login setUser={setUser} />} />
        <Route path="/criar-senha" element={<CriarSenha setUser={setUser} />} />
        <Route path="/quadro-obreiro" element={<QuadroObreiroPage />} />
        <Route path="/iniciacao" element={<IniciacaoPage />} />
        <Route path="/aniversario" element={<AniversarioPage />} />
        <Route path="/memorias-fotograficas" element={<MemoriasFotograficasPage />} />
        <Route path="/memorias-fotograficas/:id" element={<GaleriaDetailPage />} />
        <Route path="/perfil" element={<PrivateRoute element={<PerfilPage user={user} />} />} />
        <Route path="/p/:slug" element={<DynamicPage />} />
        <Route path="/gestao-anterior" element={<IframePage src="https://estrelacaldense.com.br/novo_app/GestoesAnteriores.html" />} />
        <Route path="/nominata" element={<IframePage src="https://estrelacaldense.com.br/novo_app/nominata.html" />} />
        <Route path="/regimento-interno" element={<DynamicContentPage slug="regimento-interno" />} />
        <Route path="/corpos" element={<IframePage src="https://estrelacaldense.com.br/novo_app/corposfilosoficos.html?v=1234" />} />
        <Route path="/fundadores" element={<IframePage src="https://estrelacaldense.com.br/novo_app/fundadores.html?v=1234" />} />
        <Route path="/veneraveis-mestres" element={<IframePage src="https://estrelacaldense.com.br/novo_app/veneraveis.html?v=1234" />} />
        <Route path="/nossas-escolas" element={<IframePage src="https://estrelacaldense.com.br/novo_app/escolas.html?v=1234" />} />
        <Route path="/nossa-creche" element={<IframePage src="https://estrelacaldense.com.br/novo_app/creches.html?v=1234" />} />
        <Route path="/entidades" element={<IframePage src="https://estrelacaldense.com.br/novo_app/arcoiris.html?v=1234" />} />
        <Route path="/creditos" element={<IframePage src="https://estrelacaldense.com.br/novo_app/creditos.html?v=1234" />} />
      </Routes>
    </Router>
  );
};

export default App;
